import { Component, ChangeDetectionStrategy, RESPONSE_INIT, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './not-found.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./not-found.scss']
})
export class NotFound {
  constructor() {
    // Only present during server-side rendering — lets Search Console and other crawlers see a
    // real 404 instead of a silent 200, which Google's SEO guide flags as a soft-404 anti-pattern.
    const responseInit = inject(RESPONSE_INIT, { optional: true });
    if (responseInit) {
      responseInit.status = 404;
    }
    inject(Meta).updateTag({ name: 'robots', content: 'noindex, follow' });
  }
}
